export const importFromCsv = {
  tankTitle: 'Import CSV Tank to Washing Machine',
  importTankSuccessfully: 'Import tank to washing machine successfully!',
  importTankFailed: 'Import tank to washing machine failed!',
  importSuccessfully: 'Import washing machine successfully!',
  importFailed: 'Import washing machine failed!',
}
